import {gql} from '@apollo/client';
import {PodReviewType} from '../types/PodReviewType';

// 列表查询字段（不包含详情字段）
export const POD_REVIEW_LIST_FIELDS = `
    id
    trackingNumber
    channelOrderNumber
    podReviewStatus
    podStatusUpdatedAt
    firstPodUploadTime
    podReviewMessage
    updatedAt
    client {
        id
        channelName
    }
    hub {
        id
        name
        sortingCode
    }
    whs {
        id
        name
        sortingCode
    }
    dsp {
        id
        name
        dspCode
    }
    driver {
        id
        name
        phone
    }
    lastReviewer {
        id
        name
        phone
    }
    reviewer {
        id
        name
        phone
    }
    reviewTime
    podReviewNote
    orderId
    area {
        id
        name
        sortingCode
    }
`;

// 详情查询字段（包含所有字段，包括详情专用字段）
export const POD_REVIEW_DETAIL_FIELDS = `
    id
    trackingNumber
    podReviewStatus
    recipientAddress {
        id
        fullName
        addressLine1
        addressLine2
        city
        state
        zipcode
        countryCode
        phoneNumber
        extension
        email
        company
        instructions
        latitude
        longitude
        isCoordinatesUpdated
    }
    podReviewMessage
    podReviewNote
    podImages {
        s3Key
        url
        isRisky
    }
    lastReviewer {
        id
        name
        phone
    }
    driver {
        id
        name
    }
    firstPodUploadTime
    reviewTime
    orderId
    deliveredLocation {
        latitude
        longitude
    }
    bFullAddress
    podExemptHit
    podExemptTargetType
    podExemptReasonCode
`;

export const GET_POD_REVIEW_ORDERS = gql`
    query GetPodReviewPageList(
        $pageRequest: PageRequestTypeInput,
        $tabType: Int,
        $filters: PodReviewFiltersTypeInput
    ) {
        getPodReviewPageList(
            pageRequest: $pageRequest,
            tabType: $tabType,
            filters: $filters
        ) {
            content {
                ${POD_REVIEW_LIST_FIELDS}
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;


export interface GetPodReviewOrdersResponse {
    getPodReviewPageList: PodReviewListResponseType;
}

export interface PodReviewListResponseType {
    content: PodReviewType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface GetPodReviewOrdersInput {
    pageRequest?: PageRequestTypeInput;
    tabType?: number;
    filters?: PodReviewFiltersTypeInput;
}

export interface PodReviewFiltersTypeInput {
    statusUpdatedAt?: TimeRangeTypeInput;
    podFirstUploadTime?: TimeRangeTypeInput;
    pickupHubSortingCode?: string;
    pickupHubSortingCodes?: string[];
    destWarehouseId?: string;
    destWarehouseIds?: string[];
    areaSortingCodeList?: string[];
    deliveredDspId?: string;
    deliveredDspIds?: string[];
    deliveredDriverAccountId?: string;
    // 新增筛选字段
    podReviewStatus?: string;
    trackingNumbers?: string;
    channelOrderNumbers?: string;
    reviewerId?: string;
    failureReasons?: string[];
    reviewTime?: TimeRangeTypeInput;
}

export interface TimeRangeTypeInput {
    start: string;
    end: string;
}

export interface PageRequestTypeInput {
    page: number;
    size: number;
    sortBy?: string;
    sortDirection?: string;
}

